module.exports = {
	model: {
		categoryID: false
	},

	events: {
		open: {
			type: 'click',
			action: function(event){
				event.stopImmediatePropagation();
				event.preventDefault();

				var self = event.data.component;
				if(self.model.categoryID) {
					return self.performAction(
						self.prepareAction('showInsert_categoryData', undefined, undefined, {
							source: {
								load: {
									componentData: {
										actions: {
											loadContent: {
												source: {
													load: {
														componentData: {
															model: {
																dirtyFields: {
																	data: {
																		attributes: {
																			categoryID: self.model.categoryID
																		}
																	}
																}
															}
														}
													}
												}
											}
										}
									}
								}
							}
						})
					);
				}
			}
		}
	},

	// hooks: {
	// 	onTagAdded: function($element, options){
	// 		this.callHandler('afterTagsUpdate');
	// 		// this.closest('base_tags_tagAssignment', function(tagAssignmentComponent){
	// 		// 	tagAssignmentComponent.refresh();
	// 		// })
	// 	}
	// }
}